<template>
  <component
    :is="computedTag"
    :href="href"
    class="m-message-strip"
    v-bind="$attrs"
  >
    <slot />
  </component>
</template>

<script>
import { clickableTag } from '../../../lib/type-validators'

/**
 * Mobile and desktop message strip variations based on our skin colour profiles.
 * Grey colour not used for medium skin as it does not offer enough contrast to
 * be used as a promo banner colour.
 */
export default {
  name: 'MMessageStrip',
  inheritAttrs: false,
  props: {
    /**
     * HTML tag for the component
     */
    tag: {
      type: String,
      default: null,
      validator: clickableTag,
    },
    href: {
      type: String,
      default: null,
    },
  },
  computed: {
    computedTag() {
      if (this.tag) {
        return this.tag
      }

      return this.href ? 'a' : 'div'
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../sass/framework/mixins/hover';
@use '../../../sass/framework/mixins/clickable';

.m-message-strip {
  @include hover.hover-transition(background-color, filter);
  background-color: var(--skin-background);
  color: var(--skin-color);
  display: block;
  font-size: var(--typography-paragraph-small-font-size);
  min-height: calc(
    var(--typography-paragraph-regular-line-height) * 1em + var(--spacing-32)
  );
  padding: var(--spacing-16) 0;
  text-align: center;
  text-decoration: none;

  &[href] {
    cursor: pointer;

    @include hover.hover-styles {
      background-color: var(--skin-background-hover);
    }

    &:active {
      @include clickable.clicking;
    }
  }
}
</style>
